<template>
  <div class="defaultDiv">
    <noPower></noPower>
  </div>
</template>
<script>
import noPower from "../../components/tips/noPower";
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {
    noPower
  },
  async mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.defaultDiv {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
